export enum OrganizationIntegration {
  // Value of the enum should be the __typename of the integration
  // as returned by GraphQL queries
  JIRA = 'JiraIntegration',
  JIRA_ISSUE_COLLECTOR = 'JiraIssueCollectorIntegration',
  TANIUM = 'TaniumIntegration',
  VENAFI = 'VenafiIntegration',
  CROWDSTRIKE = 'CrowdStrikeIntegration',
  SERVICE_NOW = 'ServiceNowIntegration',
}
